import { Render } from './react-declarative-render';

import ProjectVisualization from './react-components/ProjectVisualization';
import { LoadingIndicator } from './react-components/ProjectVisualization/other-components'
import WageProcessor from './react-components/WageProcessor';
import EmployeeCalendar from './react-components/EmployeeCalendar';
import WorkScheduleCalendar from './react-components/WorkScheduleCalendar';

window.CONST = require('./const');
require('./bootstrap');

// Vue Components
Vue.component('dashboard', require('./vue-components/Dashboard.vue').default);
Vue.component('resting-editor', require('./vue-components/attendance-resting/editor.vue').default);
Vue.component('time-diff', require('./vue-components/attendance-resting/time-diff.vue').default);
Vue.component('date-editor', require('./vue-components/date/editor.vue').default);
// Vue.component('dayoff-editor', require('./vue-components/dayoff/editor.vue').default);
Vue.component('manager-list', require('./vue-components/dayoff/manager-list.vue').default);
Vue.component('attendance-search', require('./vue-components/attendances/search.vue').default);
Vue.component('work-hour-editor', require('./vue-components/projects/editor.vue').default);
//Vue.component('project-visualize', require('./vue-components/projects/visualize.vue'));
//Vue.component('project-report-single', require('./vue-components/projects/visual-compare.vue'));
Vue.component('project-report', require('./vue-components/projects/report.vue').default);
Vue.component('flat-array', require('./vue-components/forms/fields/FlatArray.vue').default);
Vue.component('setting-field-array', require('./vue-components/forms/fields/Array.vue').default);
Vue.component('table-one-to-many', require('./vue-components/forms/fields/TableOneToMany.vue').default);
Vue.component('date-picker', require('./vue-components/forms/fields/DatePicker.vue').default);
Vue.component('dayoff-date-editor', require('./vue-components/forms/fields/dayoff/DayoffDateEditor.vue').default);
Vue.component('dayoff-date-reduce-editor', require('./vue-components/forms/fields/dayoff/DayoffDateReduceEditor.vue').default);

Vue.component('percent', require('./vue-components/forms/fields/Percent.vue').default);

const app = new Vue({
    el: '#main',

    data: function () {
      return Object.assign({}, window.vueData?window.vueData:{})
    },

    methods: {
        logout: function() {
            var form = document.getElementById('logout-form');
            form.submit();
        },
    },

    ready: function() {
        window.afterReady?window.afterReady():'';
    },
});

window.app = app;

// React Components

Render('project-visualization', ProjectVisualization);
Render('loading-indicator', LoadingIndicator);
Render('wage-processor', WageProcessor);
Render('employee-calendar', EmployeeCalendar);
Render('work-schedule', WorkScheduleCalendar);